import { getCategories } from '@/helpers/utilities'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import CategorySelectorItem from './CategorySelectorItem'

interface CategorySelectorProps {
  decodedActiveCategoryQuery?: string
  onSelectCategory: (selectedDecodedQueryParam: string) => void
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  decodedActiveCategoryQuery,
  onSelectCategory,
}) => {
  const { t } = useTranslation('explore')
  const categories = getCategories()

  let initialSelectedCategoryIndex = -1

  if ((decodedActiveCategoryQuery as string) === 'undefined') {
    initialSelectedCategoryIndex = 0
  } else {
    initialSelectedCategoryIndex = categories.findIndex((category) => {
      return category.decodedQueryParam === decodedActiveCategoryQuery
    })
  }

  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState<number>(
    initialSelectedCategoryIndex
  )

  // Respond to url changes triggered by filters, after page load
  useEffect(() => {
    setSelectedCategoryIndex(initialSelectedCategoryIndex)
  })

  const handleSelectCategory = (index: number) => () => {
    setSelectedCategoryIndex(index)
    const selectedCategoryDecodedQueryParam = categories[index].decodedQueryParam
    onSelectCategory(selectedCategoryDecodedQueryParam as string)
  }

  return (
    <div className='py-4' data-test='category-selector'>
      <div className='px-4'>
        <h2 className='font-quicksand font-bold text-base capitalize mb-[16px]'>
          {t('Explore_Category_Title')}
        </h2>
      </div>
      <div className='flex gap-4 whitespace-nowrap overflow-auto px-2'>
        {categories.map(({ title, iconSrc }, index) => {
          const isActive = index === selectedCategoryIndex
          return (
            <CategorySelectorItem
              index={index}
              key={title}
              title={title}
              active={isActive}
              iconSrc={iconSrc}
              onSelectCategory={handleSelectCategory(index)}
            />
          )
        })}
      </div>
    </div>
  )
}

export default CategorySelector
